
export default {
  // Reviews
  "edit_review": "리뷰 수정",
  "review": "리뷰",
  "film_friendly_score": "필름 친화도 점수",
  "hand_check": "수동 검사",
  "successful": "성공",
  "unsuccessful": "실패",
  "delete_review": "리뷰 삭제",
  "review_by": "리뷰 작성자",
};
